import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { CataloghiSection as Original } from 'components/organisms'
import {
  CataloghiSectionSettings,
  CataloghiSectionFloatingSettings,
} from './CataloghiSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'
import { cataloghiBlockItemParams } from '../CataloghiBlock'

export const defaultProps = {
  ...layoutDefaultProps('lg'),
  theme: 'neutral20',
}

export const cataloghiSectionItemParams = (enabled, id, blockProps, children) => ({
  ...layoutItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
  children: getItemChildren(enabled, children?.[2], cataloghiBlockItemParams),
})

export const dynamicProps = []

export const CataloghiSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-cataloghi-section ${props.className}`}
      >
        <Original
          item={cataloghiSectionItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

CataloghiSection.craft = withCraft({
  name: 'CataloghiSection',
  defaultProps: defaultProps,
  settings: CataloghiSectionSettings,
  floatingSettings: CataloghiSectionFloatingSettings,
})
